module.exports = function(datetime) {
    // @see http://stackoverflow.com/q/13363673
    var date = new Date(datetime.replace(/-/g, '/'))
    var diff = Date.now() - date

    var second = Math.floor(diff / 1000)
    if (second < 60) {
        return second + '秒前'
    }

    var minute = Math.floor(second / 60)
    if (minute < 60) {
        return minute + '分前'
    }

    var hour = Math.floor(minute / 60)
    if (hour < 24) {
        return hour + '時間前'
    }

    var month = date.getMonth() + 1
    var day = date.getDate()
    return month + '月' + day + '日'
}



// WEBPACK FOOTER //
// ./webroot/js/hbs_helpers/relativeTime.js